import React from 'react';
import ActivityLogsContainer from './ActivityLogsContainer';

const ActivityLogs = (props) => (
  <ActivityLogsContainer {...props} />
);

export default ActivityLogs;



// WEBPACK FOOTER //
// src/routes/ActivityLogs/index.js